/**
 * RELATÓRIO DE CLIENTES — bloqueado na fonte, e esta tela existe para DIZER
 * isso com número.
 *
 * "Clientes" estava prometido no menu (LeftBar / Breadcrumb) e não tinha rota:
 * clicava e não ia a lugar nenhum. Agora a rota existe, e o que ela mostra é o
 * motivo MEDIDO de o relatório não poder existir ainda:
 *
 *  - os clientes não são linhas: os 29 cadastros vivem dentro de UM único campo
 *    de texto, como um JSON;
 *  - `customerBalance` é nulo em todos — e saldo é a razão da tela existir;
 *  - há venda apontando para cliente que o cadastro não tem.
 *
 * Nenhum número de cliente é exibido porque nenhum é confiável, e nenhum dado
 * pessoal chega ao navegador: a API devolve CONTAGEM. Mascarar é não trazer do
 * servidor (§4).
 *
 * SÓ LEITURA (§5.1).
 */
import React, { useEffect, useState } from "react";
import * as AlfredoStyles from "../styles/components/CustomersReport";
import * as AlfredoComponents from "./";
import {
  mensagemDoErro,
  relatorioService,
} from "../services/relatorio.service";
import type { EnvelopeDeRelatorio } from "../comum/relatorios/tipos";

const CustomersReport: React.FC = () => {
  const [envelope, setEnvelope] = useState<EnvelopeDeRelatorio | null>(null);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState<string | null>(null);

  useEffect(() => {
    let cancelado = false;
    relatorioService
      .clientes()
      .then((resposta) => {
        if (!cancelado) setEnvelope(resposta);
      })
      .catch((problema) => {
        if (!cancelado) setErro(mensagemDoErro(problema));
      })
      .finally(() => {
        if (!cancelado) setCarregando(false);
      });
    return () => {
      cancelado = true;
    };
  }, []);

  return (
    <AlfredoStyles.CustomersReportContainer>
      <AlfredoStyles.Card>
        <AlfredoStyles.Icon>groups</AlfredoStyles.Icon>
        <AlfredoStyles.Title>Relatório de Clientes</AlfredoStyles.Title>

        <AlfredoComponents.CarimboDoDado
          carimbo={envelope?.carimbo}
          fonte={envelope?.fonte}
          semVenda
        />

        {carregando && <p>Medindo o cadastro no banco…</p>}
        {erro && <p>{erro}</p>}

        <AlfredoComponents.AvisosDoRelatorio
          avisos={envelope?.avisos}
          comecarAberto
        />

        <AlfredoComponents.EstadoBloqueado dados={envelope?.bloqueado} />

        {envelope && (
          <AlfredoComponents.RodapeDaFonte envelope={envelope} />
        )}
      </AlfredoStyles.Card>
    </AlfredoStyles.CustomersReportContainer>
  );
};

export default CustomersReport;
